<template>
  <div class="serp-feature-icons">
    <div v-for="feature in featureList.filter(feature => legacySerpFeatures.includes(feature))"
         :key="feature"
         class="serp-feature-icons__serp-feature__wrapper">
      <img v-tooltip.top="{content: tooltipContent[feature], ...tooltipOptions}"
           class="serp-feature-icons__serp-feature"
           :src="require(`@/assets/serp_features/${feature}.svg`)"/>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Keywords from './Keywords'

/**
 * SERP Features component. Used in {@link Keywords}
 */
export default {
  name: 'SerpFeatureIcons',
  props: {
    featureList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tooltipOptions: {
        delay: { show: 100, hide: 0 },
        classes: 'rfx-tooltip-arrow',
        trigger: 'hover'
      },
      legacySerpFeatures: [
        'answer_box',
        'local_3_pack',
        'news_pack',
        'people_also_ask',
        'video_pack'
      ],
      tooltipContent: {
        'answer_box': 'Answer Box SERP Feature',
        'brand_pack': 'Brand Pack SERP Feature',
        'image_pack': 'Image Pack SERP Feature',
        'knowledge_graph': 'Knowledge Graph SERP Feature',
        'local_3_pack': 'Local 3 Pack SERP Feature',
        'news_pack': 'News Pack SERP Feature',
        'people_also_ask': 'People Also Ask SERP Feature',
        'related_searches': 'Related Search SERP Feature',
        'shopping_box': 'Shopping Box SERP Feature',
        'video_pack': 'Video Pack SERP Feature',
        'ad_count': 'Ad Count SERP Feature',
        'geo': 'Geo SERP Feature',
        'locale': 'Locale SERP Feature',
        'total_number_of_results': 'Total Results SERP Feature'
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .serp-feature-icons {
    display: flex;
    justify-content: space-around;

    &__serp-feature {
      cursor: pointer;
    }

    &__serp-feature__wrapper {
      height: 24px;
      width: 24px;
      margin: 0 1px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

</style>
